import axios from 'axios'
import * as actions from '../../actionTypes'

const GET_CURRENT_LOGIN = 'GET_CURRENT_LOGIN'
const GET_CURRENT_LOGIN_SUCCESS = 'GET_CURRENT_LOGIN_SUCCESS'
const GET_CURRENT_LOGIN_FAILURE = 'GET_CURRENT_LOGIN_FAILURE'
const GET_CURRENT_LOGOUT = 'GET_CURRENT_LOGOUT'

const baseURL = process.env.REACT_APP_SERVICE_URL
const timeout = process.env.REACT_APP_AXIOS_TIME_OUT
const initialState = {
  authenticated: false,
}

const instance = axios.create({
  timeout: parseInt(timeout),
})

// Reducer

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENT_LOGIN_SUCCESS:
      return {
        ...state,
        authenticated: action.payload.isAuthenticated,
      }
    case GET_CURRENT_LOGIN:
    case GET_CURRENT_LOGIN_FAILURE: {
      return initialState
    }
    case GET_CURRENT_LOGOUT: {
      return initialState
    }
    case actions.CLEAR_ALL: {
      return initialState
    }
    default:
      return state
  }
}

export const loginAction = (username, password) => {
  return (dispatch) => {
    dispatch({ type: GET_CURRENT_LOGIN })
    // if (process.env.NODE_ENV === "development") {
    //   console.log("DEVELOPMENT")
    //   dispatch({
    //     type: GET_CURRENT_LOGIN_SUCCESS,
    //     payload: {
    //       isAuthenticated: true,
    //     },
    //   })
    //   return Promise.resolve();
    // }

    return instance.post(`${baseURL}auth/login`, { username, password }).then(
      (response) => {
        return response.status === 200
          ? dispatch({
            type: GET_CURRENT_LOGIN_SUCCESS,
            payload: {
              isAuthenticated: true,
            },
          })
          : dispatch({ type: GET_CURRENT_LOGIN_FAILURE })
      },
      (err) => {
        dispatch({ type: GET_CURRENT_LOGIN_FAILURE })
        throw new Error(`Error in login with username - ${username}`)
      }
    )
  }
}

export const logoutAction = () => {
  return (dispatch) => {
    return instance.post(`${baseURL}auth/logout`, {}).then(
      (response) => {
        return response.status === 204
          ? dispatch({
            type: GET_CURRENT_LOGOUT,
          })
          : dispatch({ type: GET_CURRENT_LOGOUT })
      },
      (err) => {
        dispatch({ type: GET_CURRENT_LOGOUT })
        throw new Error('Error in logout')
      }
    )
  }
}
